import { render, staticRenderFns } from "./NotificationDetail.vue?vue&type=template&id=a014ec2a&scoped=true&"
import script from "./NotificationDetail.vue?vue&type=script&lang=js&"
export * from "./NotificationDetail.vue?vue&type=script&lang=js&"
import style0 from "./NotificationDetail.vue?vue&type=style&index=0&id=a014ec2a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a014ec2a",
  null
  
)

export default component.exports